export {onBeforeRoute};

import {resolveRootMode} from '../tenant/resolve-site.js';
import {resolveSite, getTenantConfig} from '../../tenant.config.js';

// Ports the old host-based branching (fm -> Radio, vanity -> HomeSub, else normal
// routing) to run identically server/client, and rewrites per-tenant WHAT_IS.URL to a stable route.
function onBeforeRoute(pageContext) {
    const hostname = import.meta.env.SSR
        ? (pageContext.headers?.host || '').split(':')[0]
        : window.location.hostname;

    const {rootMode, subdomain} = resolveRootMode(hostname);
    const site = resolveSite(hostname);

    if (rootMode === 'fm') {
        return {pageContext: {urlLogical: '/radio', site, rootMode, hostname, subdomain}};
    }

    if (rootMode === 'vanity') {
        return {pageContext: {urlLogical: '/vanity', site, rootMode, hostname, subdomain}};
    }

    const {messages} = getTenantConfig(site);
    if (messages['WHAT_IS.URL'] && pageContext.urlPathname === messages['WHAT_IS.URL']) {
        return {pageContext: {urlLogical: '/what-is', site, rootMode, hostname, subdomain}};
    }

    return {pageContext: {site, rootMode, hostname, subdomain}};
}
